// @generated by protoc-gen-es v2.2.3 with parameter "target=js+dts"
// @generated from file anu/cat_app/site.proto (package anu.cat_app, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";
import { file_anu_cat_app_enums } from "./enums_pb";
import { file_anu_cat_app_roles } from "./roles_pb";
import { file_anu_cat_app_sas } from "./sas_pb";
import { file_anu_cat_app_user } from "./user_pb";
import { file_buf_validate_validate } from "../../buf/validate/validate_pb";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import { file_patch_go } from "../../patch/go_pb";

/**
 * Describes the file anu/cat_app/site.proto.
 */
export const file_anu_cat_app_site = /*@__PURE__*/
  fileDesc("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", [file_anu_cat_app_enums, file_anu_cat_app_roles, file_anu_cat_app_sas, file_anu_cat_app_user, file_buf_validate_validate, file_google_protobuf_timestamp, file_patch_go]);

/**
 * Describes the message anu.cat_app.GetSiteRequest.
 * Use `create(GetSiteRequestSchema)` to create a new message.
 */
export const GetSiteRequestSchema = /*@__PURE__*/
  messageDesc(file_anu_cat_app_site, 0);

/**
 * Describes the message anu.cat_app.GetSiteResponse.
 * Use `create(GetSiteResponseSchema)` to create a new message.
 */
export const GetSiteResponseSchema = /*@__PURE__*/
  messageDesc(file_anu_cat_app_site, 1);

/**
 * Describes the message anu.cat_app.PublishSiteRequest.
 * Use `create(PublishSiteRequestSchema)` to create a new message.
 */
export const PublishSiteRequestSchema = /*@__PURE__*/
  messageDesc(file_anu_cat_app_site, 2);

/**
 * Describes the message anu.cat_app.PublishSiteResponse.
 * Use `create(PublishSiteResponseSchema)` to create a new message.
 */
export const PublishSiteResponseSchema = /*@__PURE__*/
  messageDesc(file_anu_cat_app_site, 3);

/**
 * Describes the message anu.cat_app.UnpublishSiteRequest.
 * Use `create(UnpublishSiteRequestSchema)` to create a new message.
 */
export const UnpublishSiteRequestSchema = /*@__PURE__*/
  messageDesc(file_anu_cat_app_site, 4);

/**
 * Describes the message anu.cat_app.UnpublishSiteResponse.
 * Use `create(UnpublishSiteResponseSchema)` to create a new message.
 */
export const UnpublishSiteResponseSchema = /*@__PURE__*/
  messageDesc(file_anu_cat_app_site, 5);

/**
 * Describes the message anu.cat_app.ProvisionSiteRequest.
 * Use `create(ProvisionSiteRequestSchema)` to create a new message.
 */
export const ProvisionSiteRequestSchema = /*@__PURE__*/
  messageDesc(file_anu_cat_app_site, 6);

/**
 * Describes the message anu.cat_app.ProvisionSiteResponse.
 * Use `create(ProvisionSiteResponseSchema)` to create a new message.
 */
export const ProvisionSiteResponseSchema = /*@__PURE__*/
  messageDesc(file_anu_cat_app_site, 7);

/**
 * Describes the message anu.cat_app.SuspendSiteRequest.
 * Use `create(SuspendSiteRequestSchema)` to create a new message.
 */
export const SuspendSiteRequestSchema = /*@__PURE__*/
  messageDesc(file_anu_cat_app_site, 8);

/**
 * Describes the message anu.cat_app.SuspendSiteResponse.
 * Use `create(SuspendSiteResponseSchema)` to create a new message.
 */
export const SuspendSiteResponseSchema = /*@__PURE__*/
  messageDesc(file_anu_cat_app_site, 9);

/**
 * Describes the message anu.cat_app.OverrideSiteDatesRequest.
 * Use `create(OverrideSiteDatesRequestSchema)` to create a new message.
 */
export const OverrideSiteDatesRequestSchema = /*@__PURE__*/
  messageDesc(file_anu_cat_app_site, 10);

/**
 * Describes the message anu.cat_app.OverrideSiteDatesResponse.
 * Use `create(OverrideSiteDatesResponseSchema)` to create a new message.
 */
export const OverrideSiteDatesResponseSchema = /*@__PURE__*/
  messageDesc(file_anu_cat_app_site, 11);

/**
 * Describes the message anu.cat_app.OverrideSiteNameRequest.
 * Use `create(OverrideSiteNameRequestSchema)` to create a new message.
 */
export const OverrideSiteNameRequestSchema = /*@__PURE__*/
  messageDesc(file_anu_cat_app_site, 12);

/**
 * Describes the message anu.cat_app.OverrideSiteNameResponse.
 * Use `create(OverrideSiteNameResponseSchema)` to create a new message.
 */
export const OverrideSiteNameResponseSchema = /*@__PURE__*/
  messageDesc(file_anu_cat_app_site, 13);

/**
 * Describes the message anu.cat_app.OverrideLMSLegacyValueRequest.
 * Use `create(OverrideLMSLegacyValueRequestSchema)` to create a new message.
 */
export const OverrideLMSLegacyValueRequestSchema = /*@__PURE__*/
  messageDesc(file_anu_cat_app_site, 14);

/**
 * Describes the message anu.cat_app.OverrideLMSLegacyValueResponse.
 * Use `create(OverrideLMSLegacyValueResponseSchema)` to create a new message.
 */
export const OverrideLMSLegacyValueResponseSchema = /*@__PURE__*/
  messageDesc(file_anu_cat_app_site, 15);

/**
 * Describes the message anu.cat_app.ConvertToDraftRequest.
 * Use `create(ConvertToDraftRequestSchema)` to create a new message.
 */
export const ConvertToDraftRequestSchema = /*@__PURE__*/
  messageDesc(file_anu_cat_app_site, 16);

/**
 * Describes the message anu.cat_app.ConvertToDraftResponse.
 * Use `create(ConvertToDraftResponseSchema)` to create a new message.
 */
export const ConvertToDraftResponseSchema = /*@__PURE__*/
  messageDesc(file_anu_cat_app_site, 17);

/**
 * Describes the message anu.cat_app.ParentSite.
 * Use `create(ParentSiteSchema)` to create a new message.
 */
export const ParentSiteSchema = /*@__PURE__*/
  messageDesc(file_anu_cat_app_site, 18);

/**
 * Describes the message anu.cat_app.ChildSiteDetails.
 * Use `create(ChildSiteDetailsSchema)` to create a new message.
 */
export const ChildSiteDetailsSchema = /*@__PURE__*/
  messageDesc(file_anu_cat_app_site, 19);

/**
 * Describes the message anu.cat_app.SASSite.
 * Use `create(SASSiteSchema)` to create a new message.
 */
export const SASSiteSchema = /*@__PURE__*/
  messageDesc(file_anu_cat_app_site, 20);

/**
 * Describes the message anu.cat_app.GetSASSitesRequest.
 * Use `create(GetSASSitesRequestSchema)` to create a new message.
 */
export const GetSASSitesRequestSchema = /*@__PURE__*/
  messageDesc(file_anu_cat_app_site, 21);

/**
 * Describes the message anu.cat_app.GetSASSitesResponse.
 * Use `create(GetSASSitesResponseSchema)` to create a new message.
 */
export const GetSASSitesResponseSchema = /*@__PURE__*/
  messageDesc(file_anu_cat_app_site, 22);

/**
 * Describes the message anu.cat_app.ParentSiteDetails.
 * Use `create(ParentSiteDetailsSchema)` to create a new message.
 */
export const ParentSiteDetailsSchema = /*@__PURE__*/
  messageDesc(file_anu_cat_app_site, 23);

/**
 * Describes the message anu.cat_app.SandpitSite.
 * Use `create(SandpitSiteSchema)` to create a new message.
 */
export const SandpitSiteSchema = /*@__PURE__*/
  messageDesc(file_anu_cat_app_site, 24);

/**
 * Describes the message anu.cat_app.GetSandpitSitesRequest.
 * Use `create(GetSandpitSitesRequestSchema)` to create a new message.
 */
export const GetSandpitSitesRequestSchema = /*@__PURE__*/
  messageDesc(file_anu_cat_app_site, 25);

/**
 * Describes the message anu.cat_app.GetSandpitSitesResponse.
 * Use `create(GetSandpitSitesResponseSchema)` to create a new message.
 */
export const GetSandpitSitesResponseSchema = /*@__PURE__*/
  messageDesc(file_anu_cat_app_site, 26);

/**
 * Describes the message anu.cat_app.GetParentSitesRequest.
 * Use `create(GetParentSitesRequestSchema)` to create a new message.
 */
export const GetParentSitesRequestSchema = /*@__PURE__*/
  messageDesc(file_anu_cat_app_site, 27);

/**
 * Describes the message anu.cat_app.GetParentSitesResponse.
 * Use `create(GetParentSitesResponseSchema)` to create a new message.
 */
export const GetParentSitesResponseSchema = /*@__PURE__*/
  messageDesc(file_anu_cat_app_site, 28);

/**
 * Describes the message anu.cat_app.GetAcademicTermsRequest.
 * Use `create(GetAcademicTermsRequestSchema)` to create a new message.
 */
export const GetAcademicTermsRequestSchema = /*@__PURE__*/
  messageDesc(file_anu_cat_app_site, 29);

/**
 * Describes the message anu.cat_app.GetAcademicTermsResponse.
 * Use `create(GetAcademicTermsResponseSchema)` to create a new message.
 */
export const GetAcademicTermsResponseSchema = /*@__PURE__*/
  messageDesc(file_anu_cat_app_site, 30);

/**
 * Describes the message anu.cat_app.TeachingSite.
 * Use `create(TeachingSiteSchema)` to create a new message.
 */
export const TeachingSiteSchema = /*@__PURE__*/
  messageDesc(file_anu_cat_app_site, 31);

/**
 * Describes the message anu.cat_app.GetTeachingSitesRequest.
 * Use `create(GetTeachingSitesRequestSchema)` to create a new message.
 */
export const GetTeachingSitesRequestSchema = /*@__PURE__*/
  messageDesc(file_anu_cat_app_site, 32);

/**
 * Describes the message anu.cat_app.GetTeachingSitesResponse.
 * Use `create(GetTeachingSitesResponseSchema)` to create a new message.
 */
export const GetTeachingSitesResponseSchema = /*@__PURE__*/
  messageDesc(file_anu_cat_app_site, 33);

/**
 * Describes the message anu.cat_app.CommunitySite.
 * Use `create(CommunitySiteSchema)` to create a new message.
 */
export const CommunitySiteSchema = /*@__PURE__*/
  messageDesc(file_anu_cat_app_site, 34);

/**
 * Describes the message anu.cat_app.CourseDevelopmentSite.
 * Use `create(CourseDevelopmentSiteSchema)` to create a new message.
 */
export const CourseDevelopmentSiteSchema = /*@__PURE__*/
  messageDesc(file_anu_cat_app_site, 35);

